import { Box, Text } from "@usap/uicomponents";
import styled from "styled-components";
const darkSecondary = (props) => props.theme.global.colors["darkSecondary"];
const outerBorderColor = (props) => props.theme.global.colors["light-3"];
const whiteColor = (props) => props.theme.global.colors["white"];
const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  background: ${whiteColor};
  padding: 16px;
  border: 1px solid ${outerBorderColor};

  ${tabletBreakpoints} {
    padding: 24px;
  }
`;

export const ContainerTrackOrder = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  background: ${whiteColor};
  padding: 16px;
  border: 1px solid ${outerBorderColor};
  border-radius: 4px;
  height: 202px;
`;

export const ListItem = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;
export const ListItemContent = styled(Box)`
  display: flex;
  flex-direction: column;
`;
export const ListItemHeader = styled(Text)`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: ${(props) => props.theme.heading.level[6].small["size"]};
  font-style: normal;
  font-weight: 600;
  line-height: 23.1px;
  color: ${darkSecondary};
`;
export const ListItemSubHeader = styled(Text)`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: ${(props) => props.theme.heading.level[6].small["size"]};
  font-style: normal;
  font-weight: 400;
  line-height: 23.1px;
  color: ${darkSecondary};
`;
